import React, { useState } from 'react';

import { AppNavigation } from './elements/app-navigation';
import { AppBurger } from './elements/app-burger';
import { AppModal } from './elements/app-modal';

import styles from './_app-container.module.scss';

export const AppContainer = ({ children }: React.HTMLAttributes<HTMLDivElement>) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <div className={styles.root}>
      <AppBurger onClick={() => setModalIsOpen((state) => !state)} />
      <AppModal isActive={modalIsOpen} onClose={() => setModalIsOpen(false)} />
      <AppNavigation />
      <div className={styles.body}>{children}</div>
    </div>
  );
};
